export default ({ app }) => {
  const isAdmin = () => {
    try {
      const user = app.$auth && app.$auth.user
      return Boolean(
        user?.user_type?.identifier === 'admin' ||
          user?.role?.identifier === 'admin' ||
          (app.$nuxtCookies &&
            app.$nuxtCookies.get &&
            app.$nuxtCookies.get('admin_logged_in_user'))
      )
    } catch (error) {
      return false
    }
  }

  const isProtectedMedia = node =>
    node && (node.tagName === 'IMG' || node.tagName === 'VIDEO')

  const block = event => {
    if (isProtectedMedia(event.target) && !isAdmin()) {
      event.preventDefault()
    }
  }

  document.addEventListener('contextmenu', block, true)
  document.addEventListener('dragstart', block, true)

  const protectVideo = video => {
    if (isAdmin()) return
    try {
      if (video.controlsList && video.controlsList.add) {
        video.controlsList.add('nodownload')
      } else {
        video.setAttribute('controlsList', 'nodownload')
      }
      video.disablePictureInPicture = true
    } catch (error) {
      // noop
    }
  }

  const protectAllVideos = () => {
    if (isAdmin()) return
    document.querySelectorAll('video').forEach(protectVideo)
  }

  const observer = new MutationObserver(mutations => {
    if (isAdmin()) return
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return
        if (node.tagName === 'VIDEO') {
          protectVideo(node)
        } else if (node.querySelectorAll) {
          node.querySelectorAll('video').forEach(protectVideo)
        }
      })
    })
  })

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  })

  const syncProtectionClass = () => {
    const root = document.documentElement
    if (isAdmin()) {
      root.classList.remove('media-protected')
    } else {
      root.classList.add('media-protected')
      protectAllVideos()
    }
  }

  syncProtectionClass()

  if (app.router) {
    app.router.afterEach(() => syncProtectionClass())
  }
}
